import Main from '@/views/main.vue'

import {repairMenuRouter, repairOtherRouter} from './repair'
import {certificateMenuRouter} from './certificate'
import {recordMenuRouter, recordOtherRouter} from './record'
import {serviceMenuRouter} from './service'
import {homeMainRoute, homeOtherRouter} from './home'
import {orderMenuRouter} from './order'
import {deviceMenuRouter} from './device'
import {gasMenuRouter} from './gas'
import {expenseMenuRouter} from './expense'
import {messageMenuRouter, messageOtherRouter} from './message'
import {registerMenuRouter} from './register'
// import {accountMenuRouter} from './account'

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在menuRouters里
export const menuRouters = [
  homeMainRoute,
  registerMenuRouter,
  repairMenuRouter,
  certificateMenuRouter,
  gasMenuRouter,
  expenseMenuRouter,
  recordMenuRouter,
  orderMenuRouter,
  deviceMenuRouter,
  serviceMenuRouter,
  messageMenuRouter
  // accountMenuRouter
]

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouters里
export const otherRouters = [
  {
    path: '/',
    name: 'mainOtherRouter',
    redirect: '/home',
    component: Main,
    children: [
      {path: 'home', name: 'HomeIndex', title: '首页', component: () => import('@/views/gip/home/home.vue')}
    ]
  },
  repairOtherRouter,
  recordOtherRouter,
  homeOtherRouter,
  messageOtherRouter
]

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: 'Login - 登录'
  },
  component: () => import('@/views/login.vue')
}
export const uiDemoRouter = {
  path: '/uiDemo',
  name: 'uiDemo',
  meta: {
    title: 'uiDemo测试页面',
    whiteList: true
  },
  component: () => import('@/views/uiDemo.vue')
}

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  loginRouter,
  uiDemoRouter,
  ...otherRouters,
  ...menuRouters
]



// WEBPACK FOOTER //
// ./src/router/router.js